import { createContext, useContext } from 'react';

interface ReadOnlyPanelContextValue {
  isReadOnly: boolean;
  onClose?: () => void;
}

const ReadOnlyPanelContext = createContext<ReadOnlyPanelContextValue>({
  isReadOnly: false,
});

export const ReadOnlyPanelProvider = ReadOnlyPanelContext.Provider;

export const useReadOnlyPanelContext = (): ReadOnlyPanelContextValue => {
  return useContext(ReadOnlyPanelContext);
};
